import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import cls from '../styles.module.scss'

export const TextLandEs = () => {
    return (
        <HighlightedText
            text="325% de bono + 400 GIROS GRATIS"
            highlights={[{ word: '325%' }, { word: '400' }]}
            breakAfterWords={['bono', 'GIROS']}
            className={cls.text}
        />
    )
}
